import { X } from "lucide-react";
import { Button } from "~/atoms/button";
import type { FileType } from "~/api/types";
import DocumentIcon from "~/molecules/DocumentIcon";

interface FileListItemProps {
  name: string;
  subtitle: string;
  onRemove?: () => void;
}

const getFileType = (name: string): FileType =>
  (name.split(".").pop()?.toLowerCase() ?? "docx") as FileType;

export const FileListItem = ({
  name,
  subtitle,
  onRemove,
}: FileListItemProps) => (
  <div className="flex items-start justify-between gap-3">
    <div className="flex gap-3">
      <DocumentIcon
        type={getFileType(name)}
        className="text-muted-foreground size-6 shrink-0"
      />
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium break-all">{name}</p>
        <p className="text-muted-foreground text-xs">{subtitle}</p>
      </div>
    </div>
    {onRemove && (
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 shrink-0"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        <X className="size-4" />
      </Button>
    )}
  </div>
);
